/*
 * OLAITH — 제품 상세
 *
 * 여섯 가지를 한다. 앞의 둘은 관리자에서 쓴 본문을 읽어 동작하고,
 * 읽을 것이 없으면 아무 일도 하지 않는다.
 *   1) 본문의 H2 로 목차를 만들고 현재 항목을 표시한다
 *   2) 이탤릭만 있는 단락에 각주 표시를 붙인다
 *   3) 옵션 선택을 변형(variant)에 연결한다
 *   4) 총 금액 — 단가 × 수량
 *   5) 구매하기 — 담은 뒤 결제로 넘긴다
 *   6) 구매박스 높이를 늘 화면 안에 맞춘다
 */

/* ------------------------------------------------------------------
 * 1) 목차 — 본문 H2 에서 자동 생성
 * ------------------------------------------------------------------ */
function olaithBuildToc(body, toc) {
  const heads = Array.from(body.querySelectorAll('h2'));
  if (!heads.length) return;

  const list = document.createElement('ol');

  heads.forEach(function (head, i) {
    const num = String(i + 1).padStart(2, '0');
    /* 본문에 이미 id 가 있으면 그대로 두어 기존 링크를 깨지 않는다 */
    if (!head.id) head.id = 'olaith-doc-' + num;

    const link = document.createElement('a');
    link.href = '#' + head.id;
    link.dataset.target = head.id;

    const mark = document.createElement('em');
    mark.textContent = num;
    link.appendChild(mark);
    /* H2 줄에 덧붙인 글(영양성분의 열량 등, data-toc-skip)은 목차에 넣지 않는다 */
    const label = head.cloneNode(true);
    label.querySelectorAll('[data-toc-skip]').forEach(function (n) {
      n.remove();
    });
    link.appendChild(document.createTextNode(label.textContent.trim()));

    const item = document.createElement('li');
    item.appendChild(link);
    list.appendChild(item);
  });

  toc.appendChild(list);

  const links = Array.from(toc.querySelectorAll('a'));
  const setOn = function (id) {
    links.forEach(function (a) {
      a.classList.toggle('is-on', a.dataset.target === id);
    });
  };

  /* 항목 하이라이트. 화면 위쪽에 걸린 제목을 현재 항목으로 본다. */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setOn(entry.target.id);
        });
      },
      { rootMargin: '-115px 0px -60% 0px' }
    );
    heads.forEach(function (head) {
      observer.observe(head);
    });
  }

  /* 좁은 화면에서는 목차가 가로 탭이라, 현재 항목이 보이도록 밀어준다 */
  toc.addEventListener('click', function (event) {
    const link = event.target.closest('a');
    if (!link) return;
    setOn(link.dataset.target);
  });
}

/* ------------------------------------------------------------------
 * 2) 각주 — 이탤릭만 있는 단락
 *    소유주가 관리자에서 문단 전체를 기울이면 각주가 된다.
 * ------------------------------------------------------------------ */
function olaithMarkNotes(body) {
  Array.from(body.querySelectorAll('p')).forEach(function (p) {
    const kids = Array.from(p.childNodes).filter(function (n) {
      /* 공백만 있는 텍스트 노드는 세지 않는다 */
      return !(n.nodeType === 3 && !n.textContent.trim());
    });
    if (kids.length !== 1) return;

    const only = kids[0];
    if (only.nodeType !== 1) return;

    const tag = only.tagName.toLowerCase();
    if (tag === 'em' || tag === 'i') p.classList.add('is-note');
  });
}

/* ------------------------------------------------------------------
 * 3) 옵션 → 변형
 *    옵션이 실제로 있는 제품에서만 자료가 붙는다.
 * ------------------------------------------------------------------ */
function olaithBindOptions(root, setUnit) {
  const data = root.querySelector('[data-olaith-variants]');
  const selects = Array.from(root.querySelectorAll('[data-olaith-option]'));
  const idInput = root.querySelector('[data-olaith-variant-id]');
  if (!data || !selects.length || !idInput) return;

  let variants;
  try {
    variants = JSON.parse(data.textContent);
  } catch (e) {
    return;
  }

  const price = root.querySelector('[data-olaith-price]');
  const was = root.querySelector('[data-olaith-was]');
  const rate = root.querySelector('[data-olaith-rate]');
  const addButton = root.querySelector('.olaith-pd__btn--add');
  const buyButton = root.querySelector('.olaith-pd__btn--buy');

  const apply = function () {
    const chosen = selects.map(function (s) {
      return s.value;
    });
    const match = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === chosen[i];
      });
    });

    if (!match) return;

    idInput.value = match.id;
    if (price) price.textContent = match.price;
    /* 정가(그어짐)와 할인율은 비교 가격이 있는 변형에서만 보인다 */
    if (was) {
      was.textContent = match.rate > 0 ? match.was : '';
      was.hidden = !(match.rate > 0);
    }
    if (rate) {
      rate.textContent = match.rate > 0 ? match.rate + '%' : '';
      rate.hidden = !(match.rate > 0);
    }
    if (setUnit) setUnit(match.cents);
    if (addButton) {
      addButton.disabled = !match.available;
      addButton.querySelector('span').textContent = match.available
        ? '장바구니에 담기'
        : '품절';
    }
    if (buyButton) buyButton.disabled = !match.available;
  };

  selects.forEach(function (s) {
    s.addEventListener('change', apply);
  });
}

/* ------------------------------------------------------------------
 * 4) 총 금액 — 단가 × 수량
 *    표시 형식은 스토어 설정(shop.money_format)을 그대로 따른다.
 * ------------------------------------------------------------------ */
function olaithFormatMoney(cents, format) {
  const withComma = function (n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
    switch (name) {
      case 'amount':
        return withComma((cents / 100).toFixed(2));
      case 'amount_no_decimals':
        return withComma(Math.round(cents / 100));
      case 'amount_with_comma_separator':
        return withComma((cents / 100).toFixed(2)).replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
      case 'amount_no_decimals_with_comma_separator':
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      case 'amount_no_decimals_with_space_separator':
        return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      default:
        return withComma(Math.round(cents / 100));
    }
  });
}

function olaithBindTotal(root) {
  const total = root.querySelector('[data-olaith-total]');
  const value = root.querySelector('[data-olaith-total-value]');
  const input = root.querySelector('.quantity__input');
  if (!total || !value || !input) return;

  const update = function () {
    const unit = parseInt(total.dataset.unitPrice, 10);
    const qty = parseInt(input.value, 10);
    if (!isFinite(unit) || !isFinite(qty) || qty < 1) return;

    const sum = unit * qty;
    value.textContent = olaithFormatMoney(sum, total.dataset.moneyFormat);
  };

  input.addEventListener('change', update);
  input.addEventListener('input', update);
  update();

  /* 변형이 바뀌면 단가도 바뀐다 */
  return function setUnit(cents) {
    total.dataset.unitPrice = cents;
    update();
  };
}

/* ------------------------------------------------------------------
 * 5) 구매하기 — 담은 뒤 바로 결제로
 *    장바구니 버튼과 같은 폼 안에 있어 수량과 변형이 그대로 따라간다.
 *    JS 가 없으면 일반 폼 전송이 되어 장바구니까지는 간다.
 * ------------------------------------------------------------------ */
function olaithBindBuyNow() {
  document.addEventListener('click', function (event) {
    const button =
      event.target.closest && event.target.closest('[data-olaith-buynow]');
    if (!button || button.disabled) return;

    const form = button.form;
    if (!form) return;

    /* 폼 전송을 막아 Dawn 의 담기 처리가 대신 돌지 않게 한다 */
    event.preventDefault();
    button.disabled = true;

    const body = new FormData(form);
    /* 어느 버튼으로 눌렀는지는 장바구니에 보내지 않는다 */
    body.delete('add');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = window.olaithCheckout || window.Shopify.routes.root + 'checkout';
      })
      .catch(function () {
        /* 담기에 실패하면 일반 전송으로 넘겨 장바구니까지는 보낸다 */
        button.disabled = false;
        form.submit();
      });
  });
}

/* ------------------------------------------------------------------
 * 6) 구매박스 높이 — 늘 화면 안에 들어오게
 *
 * 왼쪽(사진·문서)과 오른쪽(구매박스)이 서로 상관없이 움직이려면, 오른쪽이
 * 언제나 화면 안에 통째로 들어와 있어야 한다. 그래야 그 안에서 끝까지
 * 내렸을 때 마지막 요소 아래 여유가 보이고, 여기가 끝이라는 걸 안다.
 *
 * CSS 한 줄로는 안 된다. 페이지가 맨 위에 있는 동안 구매박스는 아직 위에
 * 붙지 않고(sticky 가 걸리기 전이다) 화면보다 아래에서 시작하는데, 그
 * 시작 위치는 스크롤에 따라 계속 바뀌기 때문이다. 그래서 지금 위치를 재서
 * 화면 바닥까지 남은 만큼만 높이로 준다.
 *
 * 좁은 화면에서는 구매박스가 따라오지 않으므로 손대지 않는다.
 * ------------------------------------------------------------------ */
function olaithFitBuybox(box) {
  const narrow = window.matchMedia('(max-width: 899px)');
  const gap = 24; /* 상자 아래에 남기는 화면 여백. CSS 의 2.4rem 과 같다. */
  let queued = false;

  const fit = function () {
    queued = false;
    if (narrow.matches) {
      box.style.maxHeight = '';
      return;
    }
    const top = box.getBoundingClientRect().top;
    /* 너무 납작해지면 아무것도 못 읽으므로 하한을 둔다 */
    const room = Math.max(240, window.innerHeight - top - gap);
    box.style.maxHeight = Math.round(room) + 'px';
  };

  const ask = function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(fit);
  };

  fit();
  window.addEventListener('scroll', ask, { passive: true });
  window.addEventListener('resize', ask);
  /* 사진이 늦게 들어오면 박스 위치가 밀린다 */
  window.addEventListener('load', ask);
}

/* ------------------------------------------------------------------
 * 7) 오른쪽은 구매박스의 자리 — 휠을 구매박스로 보낸다
 *
 * 구매박스 바로 위에서만 박스가 움직이면, 박스 옆 여백(칸 사이 · 화면 끝
 * 여백)에 마우스를 둔 채 굴릴 때 페이지가 움직인다. 눈으로는 거기도
 * 구매박스 쪽이라 엉뚱하게 느껴진다(2026-10-23 소유주).
 * 그래서 칸 사이 간격의 가운데부터 오른쪽 끝까지를 구매박스 자리로 보고,
 * 그 위에서 굴린 휠은 박스를 움직인다. 박스 위에서 굴릴 때와 똑같이
 * 끝에 닿아도 페이지로 넘기지 않는다(overscroll-behavior: contain 과 같다).
 *
 * 박스가 화면 안에 다 들어와 스크롤할 것이 없으면 손대지 않는다 — 그때는
 * 오른쪽에서도 페이지가 움직인다. 좁은 화면(한 줄로 쌓일 때)도 손대지 않는다.
 * ------------------------------------------------------------------ */
function olaithWheelToBuybox(box) {
  const pd = box.closest('.olaith-pd');
  if (!pd) return;

  const narrow = window.matchMedia('(max-width: 899px)');

  pd.addEventListener(
    'wheel',
    function (event) {
      if (narrow.matches || event.ctrlKey || event.defaultPrevented) return;
      if (box.contains(event.target)) return;
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      if (box.scrollHeight <= box.clientHeight + 1) return;

      /* 칸 사이 간격의 가운데 — 그보다 오른쪽이면 구매박스 자리 */
      const gap = parseFloat(window.getComputedStyle(pd).columnGap) || 0;
      if (event.clientX < box.getBoundingClientRect().left - gap / 2) return;

      let dy = event.deltaY;
      if (event.deltaMode === 1) dy *= 16; /* 줄 단위(파이어폭스) */
      else if (event.deltaMode === 2) dy *= box.clientHeight;

      event.preventDefault();
      /* 마우스 휠의 한 칸(큰 값)은 부드럽게, 트랙패드의 잔 움직임은 그대로 */
      box.scrollBy({ top: dy, behavior: Math.abs(dy) >= 50 ? 'smooth' : 'auto' });
    },
    { passive: false }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const body = document.querySelector('[data-olaith-docbody]');
  const toc = document.querySelector('[data-olaith-toc]');

  if (body) {
    olaithMarkNotes(body);
    if (toc) olaithBuildToc(body, toc);
  }

  const root = document.querySelector('product-info');
  if (root) {
    const setUnit = olaithBindTotal(root);
    olaithBindOptions(root, setUnit);
  }

  olaithBindBuyNow();

  const buybox = document.querySelector('.olaith-pd__buybox');
  if (buybox) {
    olaithFitBuybox(buybox);
    olaithWheelToBuybox(buybox);
  }
});
